module.exports = __webpack_public_path__ + "img/symptom_default.c4b61b32.png";